import React from 'react';
import { IAuditoriaOutrasDespesasResultado } from '../interfaces/IAuditoriaOutrasDespesas';

interface Props {
  resultado: IAuditoriaOutrasDespesasResultado;
  onVerDetalhe: () => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const formatPct = (value?: number) =>
  `${(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;

const AuditoriaResumoOutrasDespesas: React.FC<Props> = ({ resultado, onVerDetalhe }) => {
  const bordaCor =
    resultado.status === 'ERRO'   ? '#f64e60' :
    resultado.status === 'ALERTA' ? '#ffa800' :
    resultado.status === 'AVISO'  ? '#ffa800' :
                                    '#1bc5bd';

  const badgeCor =
    resultado.status === 'ERRO'   ? 'danger' :
    resultado.status === 'ALERTA' ? 'warning' :
    resultado.status === 'AVISO'  ? 'warning' :
                                    'success';

  return (
    <div
      className='card card-custom card-stretch mb-5'
      style={{ borderLeft: `4px solid ${bordaCor}` }}
    >
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>
            "Lixão Contábil" — Outras Despesas Operacionais (3.01.01.08)
          </span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            Concentração de 3.01.01.08 sobre total operacional · Dual-check: absoluto e µ6m
          </span>
        </h3>
        <div className='card-toolbar'>
          <span className={`badge badge-light-${badgeCor} fs-7 fw-bold`}>
            {resultado.status}
          </span>
        </div>
      </div>

      <div className='card-body pt-3'>
        <div className='row mb-4'>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{resultado.totalErros}</div>
            <div className='text-muted fs-7'>Erros (&gt; 50%)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAlertas}</div>
            <div className='text-muted fs-7'>Alertas (35–50%)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAvisos}</div>
            <div className='text-muted fs-7'>Avisos (20–35%)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{formatCurrency(resultado.passivoTributarioTotal)}</div>
            <div className='text-muted fs-7'>Passivo Tributário</div>
          </div>
        </div>

        {resultado.status !== 'CONCILIADO' && resultado.itens.length > 0 && (
          <div className='table-responsive mb-4'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Empresa</th>
                  <th>Mês</th>
                  <th>Outras Desp.</th>
                  <th>Total Op.</th>
                  <th>Ratio</th>
                  <th>µ6m</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {resultado.itens.slice(0, 5).map((item, i) => (
                  <tr key={i}>
                    <td>
                      <span className='fw-bold'>{item.empresaNome}</span>
                      <br />
                      <span className='text-muted fs-8'>{item.cnpj}</span>
                    </td>
                    <td className='fw-bold'>{item.anoMes}</td>
                    <td>{formatCurrency(item.outrasDespesas)}</td>
                    <td>{formatCurrency(item.totalDespesas)}</td>
                    <td className='fw-bold'>{formatPct(item.ratio)}</td>
                    <td className='text-muted'>
                      {item.temMediaMovel ? formatPct(item.mediaMovel6m) : '—'}
                    </td>
                    <td>
                      <span className={`badge badge-light-${item.status === 'ERRO' ? 'danger' : 'warning'}`}>
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {resultado.status === 'CONCILIADO' && (
          <div className='text-success fw-bold fs-6'>
            ✓ Concentração de "Outras Despesas Operacionais" dentro dos limites aceitáveis. Situação regular.
          </div>
        )}

        <button className='btn btn-sm btn-light-primary mt-2' onClick={onVerDetalhe}>
          Ver detalhes
        </button>
      </div>
    </div>
  );
};

export default AuditoriaResumoOutrasDespesas;
